module.exports = __webpack_public_path__ + "img/privacy-icon.36ae0f0f.svg";